import { cn } from "@/lib/utils";
import { useProjectCreateStore } from "@/store/zustand/projectCreateStore";
import { useSelector } from "react-redux";
import AppHeader from "../AppHeader/AppHeader";

export const ProjectCreateLayout = ({
  children,
  showProjectName,
  hideCreateProject,
}: {
  children: React.ReactNode;
  showProjectName?: boolean;
  hideCreateProject?: boolean;
}) => {
  const projectIdForFlow = useProjectCreateStore(
    (state: any) => state.projectIdForFlow
  );

  const projects = useSelector((state: any) => state.supabaseStore.projects);
  const project = projects?.[projectIdForFlow];

  return (
    <>
      <div className={cn("flex flex-col items-center justify-center h-full")}>
        <div className="w-full">
          <AppHeader
            label={showProjectName ? project?.name : null}
            hideCreateProject={hideCreateProject}
          />
        </div>
        <div className="flex flex-col flex-1 justify-center items-center w-full min-h-0 grow shrink">
          {children}
        </div>
      </div>
    </>
  );
};
